<template>
	<span :class="clsx(className, 'hidden items-baseline gap-x-2 sm:flex')">
		<slot />
	</span>
</template>

<script lang="ts">
	export default { name: 'VPaginationList' } // name the component
</script>

<script setup lang="ts">
	import { 
		clsx
	} from 'clsx'

	const props = defineProps({
		className: {
			type: String,
			default: ''
		}
	})
</script>